<template>
    <div class="container base-info">
        <div class="row form-row">
            <div class="col-md-4">
                <label for="alarmGroup">
                    <span>{{ $t("알람 그룹") }}</span>
                    <i class="material-icons ml-1 req-icon">check_circle</i>
                </label>
                <valid-input
                    :vid="'알람 그룹'"
                    :classList="'form-control'"
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.alarmGroup"
                    :placeholder="$t('알람 그룹')"
                    :rules="rules.ALARM_BASE_GROUP_RULE"
                    :errorMessage="validMessage.ALARM_BASE_GROUP_VALID_MESSAGE"
                    :disabled="!isNewMode"
                ></valid-input>
            </div>
            <div class="col-md-4">
                <label for="enabled">
                    <span>{{ $t("사용여부") }}</span>
                </label>
                <select v-model="detailInfo.enabled" :disabled="!isEditMode" id="enabled" class="form-control">
                    <option value="">선택</option>
                    <option v-for="code in $store.state.commonCodes.enabled" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
            <div class="col-md-4">
                <label for="isHold">
                    <span>{{ $t("알람보류") }}</span>
                </label>
                <select v-model="holdValue" :disabled="!isEditMode" id="isHold" class="form-control">
                    <option :value="false">N</option>
                    <option :value="true">Y</option>
                </select>
            </div>
        </div>

        <div class="row form-row">
            <div class="col-md-4">
                <label for="promoteAlarmType">
                    <span>{{ $t("알람 유형") }}</span>
                    <i class="material-icons ml-1 req-icon">check_circle</i>
                </label>
                <select
                    v-model="detailInfo.promoteAlarmType"
                    :disabled="!isEditMode"
                    id="promoteAlarmType"
                    class="form-control"
                >
                    <option v-for="opt in promoteAlarmTypeOptions" :key="opt.value" :value="opt.value">
                        {{ opt.text }}
                    </option>
                </select>
            </div>
            <div class="col-md-8">
                <label for="ptAddr">
                    <span>{{ $t("관제점 주소") }}</span>
                    <i class="material-icons ml-1 req-icon">check_circle</i>
                </label>
                <input type="hidden" v-model="detailInfo.ptAddr" />
                <point-select v-model="detailInfo.ptAddr" :disabled="!isEditMode" />
            </div>
        </div>

        <div class="row form-row">
            <div class="col-md-6">
                <label for="alarmType">
                    <span>{{ $t("판정 방식") }}</span>
                </label>
                <select
                    v-model="detailInfo.alarmType"
                    :disabled="!isEditMode"
                    id="alarmType"
                    class="form-control"
                    @change="onAlarmTypeChange"
                >
                    <option value="A0">Low / High</option>
                    <option value="A1">Low low / High high</option>
                    <option value="D0">True / False</option>
                    <option value="D1">상태 변경</option>
                </select>
            </div>
            <div class="col-md-6" v-if="detailInfo.alarmType === 'D0'">
                <label for="digitalWhen">
                    <span>{{ $t("관제점 값") }}</span>
                </label>
                <select
                    v-model.number="digitalAlarmWhen"
                    :disabled="!isEditMode"
                    id="digitalWhen"
                    class="form-control"
                >
                    <option :value="1">True (1) 일 때 알람</option>
                    <option :value="0">False (0) 일 때 알람</option>
                </select>
            </div>
        </div>

        <div class="row form-row" v-if="isAnalogType">
            <div class="col-md-3" v-if="detailInfo.alarmType === 'A1'">
                <label for="ll"><span>LL</span></label>
                <valid-input
                    :inputType="'number'"
                    :classList="'form-control'"
                    :placeholder="'Low Low'"
                    :inputValue.sync="detailInfo.ll"
                    :rules="rules.ALARM_BASE_VALUE_LL_RULE"
                    :NonStatus="true"
                    :disabled="!isEditMode"
                ></valid-input>
            </div>
            <div class="col-md-3">
                <label for="l"><span>L</span></label>
                <valid-input
                    :vid="'L'"
                    :inputType="'number'"
                    :classList="'form-control'"
                    :placeholder="'Low'"
                    :inputValue.sync="detailInfo.l"
                    :rules="rules.ALARM_BASE_VALUE_L_RULE"
                    :errorMessage="validMessage.ALARM_BASE_VALUE_L_VALUE_H_VALID_MESSAGE"
                    :disabled="!isEditMode"
                ></valid-input>
            </div>
            <div class="col-md-3">
                <label for="h"><span>H</span></label>
                <valid-input
                    :vid="'H'"
                    :inputType="'number'"
                    :classList="'form-control'"
                    :placeholder="'High'"
                    :inputValue.sync="detailInfo.h"
                    :rules="rules.ALARM_BASE_VALUE_H_RULE"
                    :errorMessage="validMessage.ALARM_BASE_VALUE_L_VALUE_H_VALID_MESSAGE"
                    :disabled="!isEditMode"
                ></valid-input>
            </div>
            <div class="col-md-3" v-if="detailInfo.alarmType === 'A1'">
                <label for="hh"><span>HH</span></label>
                <valid-input
                    :inputType="'number'"
                    :classList="'form-control'"
                    :placeholder="'High High'"
                    :inputValue.sync="detailInfo.hh"
                    :rules="rules.ALARM_BASE_VALUE_HH_RULE"
                    :NonStatus="true"
                    :disabled="!isEditMode"
                ></valid-input>
            </div>
        </div>

        <div class="row form-row" v-if="detailInfo.alarmType === 'D0'">
            <div class="col-md-6">
                <label for="confirmMode">
                    <span>{{ $t("알람 발생 조건") }}</span>
                </label>
                <select
                    v-model="detailInfo.confirmMode"
                    :disabled="!isEditMode"
                    id="confirmMode"
                    class="form-control"
                >
                    <option value="immediate">즉시 알람</option>
                    <option value="sustain">지속 확인 후 알람</option>
                </select>
            </div>
            <div class="col-md-4" v-if="detailInfo.confirmMode === 'sustain'">
                <label for="confirmMinutes">
                    <span>{{ $t("지속 시간") }}</span>
                </label>
                <div class="input-group">
                    <input
                        id="confirmMinutes"
                        v-model.number="detailInfo.confirmMinutes"
                        type="number"
                        min="1"
                        max="10080"
                        step="1"
                        class="form-control"
                        :disabled="!isEditMode"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text">분</span>
                    </div>
                </div>
            </div>
            <div class="col-md-12" v-if="isEditMode">
                <p class="confirm-summary">{{ d0ConditionText }}</p>
            </div>
        </div>

        <div class="row form-row" v-if="detailInfo.alarmType === 'D1'">
            <div class="col-md-6">
                <label for="changeConfirmMode">
                    <span>{{ $t("알람 발생 조건") }}</span>
                </label>
                <select
                    v-model="detailInfo.confirmMode"
                    :disabled="!isEditMode"
                    id="changeConfirmMode"
                    class="form-control"
                >
                    <option value="immediate">즉시 알람</option>
                    <option value="sustain">지속 확인 후 알람</option>
                </select>
            </div>
            <div class="col-md-4" v-if="detailInfo.confirmMode === 'sustain'">
                <label for="changeConfirmMinutes">
                    <span>{{ $t("지속 시간") }}</span>
                </label>
                <div class="input-group">
                    <input
                        id="changeConfirmMinutes"
                        v-model.number="detailInfo.confirmMinutes"
                        type="number"
                        min="1"
                        max="10080"
                        step="1"
                        class="form-control"
                        :disabled="!isEditMode"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text">분</span>
                    </div>
                </div>
            </div>
            <div class="col-md-12" v-if="isEditMode">
                <p class="confirm-summary">{{ d1ConditionText }}</p>
            </div>
        </div>

        <div class="row form-row">
            <div class="col-md-12">
                <label for="description">
                    <span>{{ $t("경고메세지") }}</span>
                </label>
                <div v-if="splitWarningMessage">
                    <div class="state-msg" v-for="row in messageRows" :key="row.key">
                        <span class="state-msg-label">{{ row.label }} 일 때</span>
                        <textarea
                            v-model="row.text"
                            rows="2"
                            class="form-control"
                            :disabled="!isEditMode"
                        ></textarea>
                    </div>
                </div>
                <valid-textarea
                    v-else
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.description"
                    :NonStatus="true"
                    :textareaRow="4"
                    :classList="'desc-ctn form-control'"
                    :rules="rules.ALARM_BASE_WARN_MESSAGE_RULE"
                    :disabled="!isEditMode"
                ></valid-textarea>
            </div>
        </div>

        <div class="row form-row">
            <div class="col-md-12">
                <label for="solution">
                    <span>{{ $t("해결방안") }}</span>
                </label>
                <valid-textarea
                    :inputType="'text'"
                    :inputValue.sync="detailInfo.solution"
                    :NonStatus="true"
                    :textareaRow="3"
                    :classList="'desc-ctn form-control'"
                    :rules="rules.ALARM_BASE_SOLVED_RULE"
                    :disabled="!isEditMode"
                ></valid-textarea>
            </div>
        </div>

        <div class="row form-row" v-xe-pm.E.A v-if="!isMobile && !isNewMode">
            <div class="col-md-8">
                <label for="testVal">
                    <span>{{ $t("알람테스트") }}</span>
                </label>
                <div class="test-row">
                    <valid-input
                        :inputType="'number'"
                        :classList="'form-control'"
                        :placeholder="$t('알람테스트 값')"
                        :inputValue.sync="detailInfo.testVal"
                        :rules="rules.ALARM_BASE_TEST_VALUE_RULE"
                        :NonStatus="true"
                        :disabled="!isEditMode"
                    ></valid-input>
                    <button
                        class="btn btn-success"
                        type="button"
                        :disabled="!isEditMode"
                        @click="$emit('test-alarm', detailInfo.testVal)"
                    >
                        {{ $t("실행") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
import { confirmUiFromRuleParams, describeChangeRule, messageRowsFromRuleParams } from "./ruleParamsUi.js";

export default {
    props: ["detailInfo", "mode"],
    data() {
        return {
            rules,
            validMessage,
            stateCodes: [],
        };
    },
    computed: {
        isEditMode() {
            return this.mode !== "view";
        },
        isAnalogType() {
            return this.detailInfo.alarmType === "A0" || this.detailInfo.alarmType === "A1";
        },
        /** 상태 변경이면 경고메세지를 0 / 1 두 칸으로 나눈다. 관제점 값 유형은 보지 않는다. */
        splitWarningMessage() {
            return this.detailInfo.alarmType === "D1";
        },
        messageRows() {
            return this.detailInfo.messageRows || [];
        },
        isNewMode() {
            return this.mode === "new";
        },
        promoteAlarmTypeOptions() {
            const allowed = ["Event", "EquipFault"];
            const codes = this.$store.state.commonCodes?.alarmType || [];
            const fromStore = codes.filter((c) => allowed.includes(c.value));
            if (fromStore.length >= allowed.length) return fromStore;
            return [
                { value: "Event", text: "이벤트" },
                { value: "EquipFault", text: "설비 오류" },
            ];
        },
        holdValue: {
            get() {
                return !!this.detailInfo.isHold;
            },
            set(val) {
                this.$set(this.detailInfo, "isHold", !!val);
            },
        },
        digitalAlarmWhen: {
            get() {
                if (this.detailInfo.hh === 0 || this.detailInfo.hh === "0") return 0;
                return 1;
            },
            set(val) {
                this.$set(this.detailInfo, "hh", Number(val) === 0 ? 0 : 1);
            },
        },
        d0ConditionText() {
            const valueText = this.digitalAlarmWhen === 0 ? "False(0)" : "True(1)";
            if (this.detailInfo.confirmMode === "sustain") {
                const minutes = Math.floor(Number(this.detailInfo.confirmMinutes));
                const duration = Number.isFinite(minutes) && minutes > 0 ? `${minutes}분 동안 ` : "";
                return `${duration}${valueText} 일 때 알람이 발생합니다.`;
            }
            return `${valueText} 일 때 알람이 발생합니다.`;
        },
        d1ConditionText() {
            return describeChangeRule({
                mode: this.detailInfo.confirmMode,
                minutes: this.detailInfo.confirmMinutes,
            });
        },
    },
    watch: {
        "detailInfo.alarmType"() {
            this.ensureRuleUi();
            this.syncStateMessages();
        },
    },
    mounted() {
        this.ensureRuleUi();
        this.syncStateMessages();
    },
    methods: {
        /** 저장된 ruleParams를 화면 전용 필드로 펼친다. 이미 있으면 건드리지 않는다. */
        ensureRuleUi() {
            if (!this.detailInfo) return;

            if (!this.detailInfo.messageRows) {
                this.$set(this.detailInfo, "messageRows", messageRowsFromRuleParams(this.detailInfo.ruleParams));
            }

            const alarmType = this.detailInfo.alarmType;
            if (alarmType !== "D0" && alarmType !== "D1") return;
            if (!this.detailInfo.confirmMode) {
                const ui = confirmUiFromRuleParams(this.detailInfo.ruleParams);
                this.$set(this.detailInfo, "confirmMode", ui.mode);
                this.$set(this.detailInfo, "confirmMinutes", ui.minutes);
            }
        },
        /** 상태 변경이면 경고메세지를 0 / 1 두 칸으로 나눈다. */
        syncStateMessages() {
            if (!this.detailInfo || this.detailInfo.alarmType !== "D1") {
                this.applyStateCodes([]);
                return;
            }
            this.applyStateCodes([
                { value: "1", label: "True (1)" },
                { value: "0", label: "False (0)" },
            ]);
        },
        applyStateCodes(codes) {
            if (!this.detailInfo) return;
            this.stateCodes = codes;
            const written = new Map((this.detailInfo.messageRows || []).map((row) => [String(row.key), row.text]));
            this.$set(
                this.detailInfo,
                "messageRows",
                codes.map((code) => {
                    const key = String(code.value);
                    return { key, label: code.label || key, text: written.has(key) ? written.get(key) : "" };
                })
            );
        },
        onAlarmTypeChange() {
            if (this.detailInfo.alarmType === "D0") {
                if (this.detailInfo.hh !== 0 && this.detailInfo.hh !== 1) {
                    this.$set(this.detailInfo, "hh", 1);
                }
                if (this.isEmpty(this.detailInfo.l)) this.$set(this.detailInfo, "l", 0);
                if (this.isEmpty(this.detailInfo.h)) this.$set(this.detailInfo, "h", 0);
                this.ensureRuleUi();
            } else if (this.detailInfo.alarmType === "D1") {
                if (this.isEmpty(this.detailInfo.l)) this.$set(this.detailInfo, "l", 0);
                if (this.isEmpty(this.detailInfo.h)) this.$set(this.detailInfo, "h", 0);
                this.$set(this.detailInfo, "ll", null);
                this.$set(this.detailInfo, "hh", null);
                this.ensureRuleUi();
            } else if (this.detailInfo.alarmType === "A0") {
                this.$set(this.detailInfo, "ll", null);
                this.$set(this.detailInfo, "hh", null);
            } else if (this.detailInfo.alarmType === "A1") {
                if (this.detailInfo.hh === 0 || this.detailInfo.hh === 1) {
                    this.$set(this.detailInfo, "hh", null);
                }
            }
        },
    },
};
</script>

<style scoped>
.base-info {
    height: 100%;
    width: 100%;
    max-width: 100%;
    padding: 0 4px 12px;
    margin: 0;
}

.form-row {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 18px;
}

.form-row > [class*="col-"] {
    padding-left: 8px;
    padding-right: 8px;
}

.base-info label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
    color: #444;
}

.req-icon {
    font-size: 0.8rem !important;
    vertical-align: middle;
}

.test-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.test-row .btn {
    flex-shrink: 0;
    min-width: 72px;
}

.confirm-summary {
    margin: 8px 0 0;
    font-size: 12px;
    color: #999;
}

.state-msg + .state-msg {
    margin-top: 10px;
}

.state-msg-label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 500;
    color: #666;
}
</style>
